import { Button, Modal, Form, Input, message, Radio } from "antd";
import API from "../../../../services/api-request";
import SelectProductType from "../../../../components/SelectProductType";

const AddProduct = (props) => {
  const [addForm] = Form.useForm();

  const options = [
    { label: "Ya", value: 1 },
    { label: "Tidak", value: 0 },
  ];

  const onFinish = async (values) => {
    const { name, description, product_type_id, show_in_dashboard } = values;

    const dataForm = {
      name,
      description: typeof description === "undefined" ? "" : description,
      product_type_id,
      show_in_dashboard,
    };

    await API.Post("product", dataForm)
      .then(() => {
        message.success("Product has been added");
        props.onGetProduct();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <Modal
      title="Add Product"
      open={props.showAdd}
      onCancel={handleCancel}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={() => addForm.submit()}>
          Submit
        </Button>,
      ]}
    >
      <Form
        form={addForm}
        name="Add Form"
        style={{
          margin: "0 auto",
        }}
        initialValues={{
          show_in_dashboard: 1,
        }}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Product Type"
          name="product_type_id"
          rules={[{ required: true, message: "Please input product type!" }]}
        >
          <SelectProductType />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input name!" }]}
        >
          <Input placeholder="Input Name" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input placeholder="Input description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddProduct;
